import { makeAutoObservable } from 'mobx';
import { clearPersistedStore, makePersistable } from 'mobx-persist-store';

export const FORM_STORE_NAME = 'serviceDirectoryFormStore';

class ServiceDirectoryFormStore {
  params = JSON.stringify({});

  constructor(rootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);

    makePersistable(this, {
      name: FORM_STORE_NAME,
      properties: ['params'],
    });
  }

  set(newParams) {
    this.params = JSON.stringify({ ...newParams });
  }

  get() {
    return JSON.parse(this.params);
  }

  async clearStore() {
    await clearPersistedStore(this);
  }
}

export default ServiceDirectoryFormStore;
